<template>
    <div>
      <lexology-list></lexology-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>